<template>
  <main v-if="isAcceptStatusCode" class="position-relative error">
    <div class="error-content">
      <div :class="statusText" class="error-pic">
        <img
          :src="
            `https://ik.imagekit.io/1pzxddx3qqv/mc/img/error-pic-${statusText}.png`
          "
          :alt="`error-pic-${statusText}`"
        />
      </div>
      <div class="error-block">
        <h6 class="error-title-tip">
          {{ titleTip }}
        </h6>
        <h6 class="error-title">
          {{ title }}
        </h6>
        <h3 :class="statusText" class="fw-normal error-subTitle">
          {{ formatSubTitle }}
        </h3>
        <div
          v-if="statusText === 'maintain'"
          class="d-flex flex-column flex-lg-row mb-4 mb-lg-0"
        >
          <div class="error-tip">
            <p class="mb-2 error-tip-text">
              {{ $t('layout.error.tip.text') }}
            </p>
            <p
              v-if="maintainStartTime && maintainEndTime"
              class="error-tip-time text-center mb-3"
            >
              {{ maintainStartTime + '-' + maintainEndTime }}
            </p>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <button v-if="false" class="btn btn-main error-btn" @click="reload">
            <i class="mc-update"></i>
            <span class="ms-2">{{ $t('layout.error.reload') }}</span>
          </button>
          <button
            v-if="[404, 400].includes(statusCode)"
            class="btn btn-primary error-btn"
            @click.prevent="$router.push('/')"
          >
            <i v-if="false" class="mc-return"></i>
            <span class="ms-2">{{ $t('layout.error.backHome') }}</span>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  computed,
  defineComponent,
  toRef,
  useStore
} from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    statusCode: {
      type: Number,
      required: true
    },
    titleTip: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    maintainStartTime: {
      type: String,
      default: null
    },
    maintainEndTime: {
      type: String,
      default: null
    }
  },
  setup(props, context) {
    const store = useStore()

    const templateId = computed(() => process.env.TEMPLATE_ID)
    const isMobile = computed(() => store.state.isMobile)
    const subTitle = toRef(props, 'subTitle')
    const formatSubTitle = computed(() =>
      subTitle.value.replace(/(<br \/>)/g, '、')
    )
    const statusCode = toRef(props, 'statusCode')
    const statusText = computed(() => {
      switch (statusCode.value) {
        case 400:
        case 500:
          return 'under'
        case 503:
        case 599:
          return 'maintain'
        case 403:
          return 'ip-limit'
        default:
          return 'no-service'
      }
    })
    const isAcceptStatusCode = computed(() => {
      switch (statusCode.value) {
        case 400:
        case 403:
        case 404:
        case 500:
        case 503:
        case 599:
          return true
        default:
          return false
      }
    })

    function reload() {
      context.emit('reload')
    }

    return {
      templateId,
      isMobile,
      formatSubTitle,
      statusText,
      isAcceptStatusCode,

      reload
    }
  }
})
</script>
